export default __webpack_public_path__ + "static/media/dojang_web.81b7e33f.jpeg";